import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// shared modules
import { SharedModule } from '../shared/shared.module';

// containers
//import { LoginOverlaySectionComponent } from './containers/login-overlay-section/login-overlay-section.component';
import { LoginOverlaySectionComponent } from '../../app/login-overlay/containers/login-overlay-section/login-overlay-section.component';

// components
// import { OneFactorComponent } from './components/one-factor/one-factor.component';
// import { TwoFactorComponent } from './components/two-factor/two-factor.component';
import { OneFactorComponent } from '../../app/login-overlay/components/one-factor/one-factor.component';
import { TwoFactorComponent } from '../../app/login-overlay/components/two-factor/two-factor.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  declarations: [
    LoginOverlaySectionComponent,
    OneFactorComponent,
    TwoFactorComponent
  ],
  exports: [
    LoginOverlaySectionComponent
  ]
})
export class LoginOverlaySectionModule { }
